import gql from 'graphql-tag';

const QUERY_ESIMS = gql`
  query esims($filter: ListEsimsFilterInput, $limit: Int) {
    esims(filter: $filter, limit: $limit) {
      isSuccess
      message
      esims {
        id
        compatibleBrand
        compatibleModel
        status
        license {
          id
          isAllowedDual
          licenseType
          name
          productId
          storage
        }
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export default QUERY_ESIMS;
